import { render, staticRenderFns } from "./AgentInfo.vue?vue&type=template&id=4a5b225f&scoped=true"
import script from "./AgentInfo.vue?vue&type=script&lang=js"
export * from "./AgentInfo.vue?vue&type=script&lang=js"
import style0 from "./AgentInfo.vue?vue&type=style&index=0&id=4a5b225f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5b225f",
  null
  
)

export default component.exports